import React, {useState} from "react";
import NftCard from "../../../GlobalComponents/NftCard/NftCard";
import thum from "../assets/tum.png";
import NftCardLarge from "../NftCardLarge/NftCardLarge";
const UsingTheNFT = () => {
  return (
    <div className="max-w-[877px] px-3 md:px-0 mx-auto mt-[253px]">
      <div className="text-center flex flex-col items-center mb-[50px]">
        <h2 className="text-res-lg font-black mb-[11px]">Using the NFTs</h2>
        <p className="text-res-xs font-semibold leading-[30px] md:w-[765px]">
          To become a member of the R34P DAO, you'll need to hold one of two
          types of NFTs. These NFTs represent your ownership stake in the DAO
          and give you the ability to vote on governance decisions, participate
          in funding rounds, and earn rewards for your contributions. Here are
          the details for each tier:
        </p>
      </div>
      <div className="flex flex-col md:flex-row  gap-[33px] ">
        <div className="md:min-w-[409px]">
          <NftCardLarge thum={thum} gold={true}></NftCardLarge>
        </div>
        <div className="grow">
          <div className="mt-[22px]">
            <h2 className="font-black text-res-sm mb-[7px]">NFT Features</h2>
            <p className="font-semibold text-res-xs ">
              Lorem ipsum dolor sit amet consectetur. Gravida non dolor vitae
              facilisi nisl mattis imperdiet mi. Purus iaculis non arcu nunc
              nulla leo etiam cras. Facilisis enim pretium enim tristique amet
              in nullam adipiscing ultricies.
              <br />
              <span className="pt-[10px] inline-block">
                Purus iaculis non arcu nunc nulla leo etiam cras. Facilisis enim
                pretium enim tristique amet in nullam adipiscing ultricies. Elit
                consectetur sed faucibus et ac a.
              </span>
            </p>
          </div>
          <div className="mt-[30px]">
            <h2 className="font-black text-res-sm mb-[7px]">Tokens Vested</h2>
            <p className="font-semibold text-res-xs ">
              Lorem ipsum dolor sit amet consectetur. Gravida non dolor vitae
              facilisi nisl mattis imperdiet mi. Purus iaculis non arcu nunc
              nulla leo etiam cras. Facilisis enim pretium enim tristique amet
              in nullam adipiscing ultricies.
              <br />
              <span className="pt-[10px] inline-block">
                Purus iaculis non arcu nunc nulla leo etiam cras. Facilisis enim
                pretium enim tristique amet in nullam adipiscing ultricies. Elit
                consectetur sed faucibus et ac a.
              </span>
            </p>
          </div>
          <div className="mt-[30px]">
            <h2 className="font-black text-res-sm mb-[7px]">
              Bidding & Buying
            </h2>
            <p className="font-semibold text-res-xs ">
              Lorem ipsum dolor sit amet consectetur. Gravida non dolor vitae
              facilisi nisl mattis imperdiet mi. Purus iaculis non arcu nunc
              nulla leo etiam cras. Facilisis enim pretium enim tristique amet
              in nullam adipiscing ultricies.
              <br />
              <span className="pt-[10px] inline-block">
                Purus iaculis non arcu nunc nulla leo etiam cras. Facilisis enim
                pretium enim tristique amet in nullam adipiscing ultricies. Elit
                consectetur sed faucibus et ac a.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsingTheNFT;
